import * as React from 'react';
import { View } from 'react-native';
import CommonCircle from './components/CommonCircle';
import CommonCamel from './components/CommonCamel';
import FullCamel from './components/FullCamel';
import FullCircle from './components/FullCircle';
const DEFAULT_PROPS = {
    type: 'circle'
};
export default class Loading extends React.PureComponent {
    render() {
        const props = Object.assign(Object.assign({}, DEFAULT_PROPS), this.props);
        const { type, text, showClose, onClose, customStyle } = props;
        let loadingView = <View />;
        switch (type) {
            case 'circle': {
                loadingView = (<CommonCircle text={text} showClose={showClose} onClose={onClose}/>);
                break;
            }
            case 'fullCircle': {
                loadingView = (<FullCircle text={text} showClose={showClose} onClose={onClose} customStyle={customStyle}/>);
                break;
            }
            case 'camel': {
                loadingView = <CommonCamel text={text}/>;
                break;
            }
            case 'fullCamel': {
                loadingView = (<FullCamel text={text} customStyle={customStyle}/>);
                break;
            }
            default:
                break;
        }
        return loadingView;
    }
}
